import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";

class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[GlobalErrorBoundary]", error, errorInfo);
  }

  handleRetry = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("_subdomain");
    window.location.href = "/login";
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="sm" sx={{ mt: 10 }}>
          <Paper elevation={3} sx={{ p: 5, textAlign: "center", borderRadius: 3 }}>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, color: "#344767" }}>
              Something went wrong
            </Typography>
            <Typography variant="body1" sx={{ mb: 4, color: "#67748e" }}>
              The application encountered an unexpected error. You can try again, go back to the
              dashboard, or log out and sign in again.
            </Typography>
            {this.state.error && (
              <Box
                sx={{
                  mb: 3,
                  p: 2,
                  backgroundColor: "#fef2f2",
                  borderRadius: 2,
                  textAlign: "left",
                  maxHeight: 120,
                  overflow: "auto",
                }}
              >
                <Typography variant="caption" sx={{ fontFamily: "monospace", color: "#991b1b" }}>
                  {this.state.error.toString()}
                </Typography>
              </Box>
            )}
            <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
              <Button variant="contained" onClick={this.handleRetry} sx={{ textTransform: "none" }}>
                Try Again
              </Button>
              <Button
                variant="outlined"
                onClick={this.handleGoHome}
                sx={{ textTransform: "none" }}
              >
                Go to Dashboard
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={this.handleLogout}
                sx={{ textTransform: "none" }}
              >
                Logout
              </Button>
            </Box>
          </Paper>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
